export const USER_LOGGING_IN = 'USER_LOGGING_IN'
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const USER_REFRESH_TOKEN = 'USER_REFRESH_TOKEN'

export const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS'

export const OPEN_NOT_AUTHORIZED = 'OPEN_NOT_AUTHORIZED'
export const CLOSE_NOT_AUTHORIZED = 'CLOSE_NOT_AUTHORIZED'


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js